import { createValidIcon } from '@ui/icons/utils/type-helper'

export const StatusCancelledIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M10 1.66699C14.6024 1.66699 18.333 5.39763 18.333 10C18.333 14.6024 14.6024 18.333 10 18.333C5.39763 18.333 1.66699 14.6024 1.66699 10C1.66699 5.39763 5.39763 1.66699 10 1.66699ZM10 3.33301C6.3181 3.33301 3.33301 6.3181 3.33301 10C3.33301 13.6819 6.3181 16.667 10 16.667C13.6819 16.667 16.667 13.6819 16.667 10C16.667 6.3181 13.6819 3.33301 10 3.33301ZM11.9102 6.91113C12.2356 6.5857 12.7634 6.5857 13.0889 6.91113C13.4142 7.23656 13.4142 7.76344 13.0889 8.08887L11.1787 10L13.0889 11.9102C13.4143 12.2356 13.4143 12.7634 13.0889 13.0889C12.7634 13.4143 12.2356 13.4143 11.9102 13.0889L10 11.1787L8.08887 13.0889C7.76344 13.4142 7.23656 13.4142 6.91113 13.0889C6.5857 12.7634 6.5857 12.2356 6.91113 11.9102L8.82129 10L6.91113 8.08887C6.5857 7.76343 6.5857 7.23657 6.91113 6.91113C7.23657 6.5857 7.76343 6.5857 8.08887 6.91113L10 8.82129L11.9102 6.91113Z'
        fill={color}
      />
    </svg>
  )
})
